import React, { useState, useRef, useReducer } from 'react';
import { Form, Modal, Table, Tabs } from 'antd';
import { Checkbox, InfoBox, Layout, MobileTabBar, Button, Input, SelectFile, Footer } from 'components';
import classNames from "classnames";


import RightChevronIcon from 'assests/icons/right-chevron.icon';
import { NavLink } from 'react-router-dom';
import OptOutTable from './opt-out-table';
import OptInTable from './opt-in-table';
const { TabPane } = Tabs;


const BlackList = () => {
  
  const [contentName, setContentName] = useState('group--1');
  return (
    <Layout>
      <div className='routing'>
        <NavLink to="/Messages" activeClassName="active">
          <span>Mesaj Gönder</span>
        </NavLink>
        <NavLink to="/Guide" activeClassName="active">
          <span>Rehberim</span>
        </NavLink>
        <NavLink to="/BlackList" activeClassName="active">
          <span>Kara Liste</span>
        </NavLink>
      </div>
      <div className="messages-page messages-tab black-list">
        <div className='container'>
          <h1 className='section__title'>Kara Liste</h1>
          <div className='box'>
            <div className='group-titles'>
              <div className='sub-groups'>
                <ul>
                  <li className={classNames({'active' : contentName === 'group--1'})} onClick={ () => {
                    setContentName('group--1')
                  } }>
                    <span>Kara Listedeki Kullanıcılar</span>
                    <RightChevronIcon />
                  </li>
                  <li className={classNames({'active' : contentName === 'group--2'})} onClick={ () => {
                    setContentName('group--2')
                  } }>
                    <span>Kara Listeden Çıkanlar</span>
                    <RightChevronIcon />
                  </li>
                </ul>
              </div>
            </div>
            <Tabs defaultActiveKey="1" onChange={ (item) => {setContentName(`group--${item}`)} } renderTabBar={ (props, Item) => { return <MobileTabBar props={props} item={Item}/> } } >
              <TabPane tab="Kara Listedeki Kullanıcılar" key="1">
              </TabPane>
              <TabPane tab="Kara Listeden Çıkanlar" key="2">
              </TabPane>
            </Tabs>
            { contentName === 'group--1' ?
              <OptOutTable/>
              :
              <OptInTable />
            }
          </div>
        </div>
      </div>
      <Footer />
    </Layout>
  )
}

export default BlackList;